<template>
  <AccountWrapper class="content">
    <template #title>{{ t('account.dateRequests.title') }}</template>

    <div v-if="isLoading && !dateRequests.length" class="text-sm text-gray-500">
      {{ t('general.loading') }}
    </div>

    <div v-else-if="error" class="text-sm text-red-600">
      {{ t('general.error') }}
    </div>

    <div v-else-if="!dateRequests.length" class="text-sm text-gray-500">
      {{ t('account.dateRequests.empty') }}
    </div>

    <template v-else>
      <AccountDateRequestCard
        v-for="dateRequest in dateRequests"
        :key="dateRequest.id"
        :date-request="dateRequest"
        class="mb-8"
      />

      <Button
        v-if="hasMore"
        variant="outlined"
        class="w-full"
        :disabled="isLoading"
        @click="loadMoreDateRequests"
      >
        {{ isLoading ? t('general.loading') : t('general.more') }}
      </Button>
    </template>
  </AccountWrapper>
</template>

<script setup lang="ts">
const { t } = useI18n()
const {
  dateRequests,
  isLoading,
  error,
  hasMore,
  fetchDateRequests,
  loadMoreDateRequests,
} = useAccountDateRequests()

onMounted(async () => {
  if (dateRequests.value.length) {
    return
  }

  await fetchDateRequests()
})

definePageMeta({
  middleware: ['auth'],
  requiresAuth: true,
  isSimpleFooter: true,
})
</script>

<style lang="postcss" scoped>
.content {
  :deep(.account-area__content) {
    box-shadow: 0 0 20px 0 rgba(76, 87, 125, 0.06);

    @apply rounded-lg p-2.5;
  }
}
</style>
